module.exports = __webpack_public_path__ + "img/h5logo.05940e90.png";